/**
 * Quotation puzzles — well-known quotations from public-domain or widely-
 * quoted sources. Limited to short, single-line sayings the audience will
 * recognize without crediting. (We never display the attribution as part
 * of the puzzle text — too long for the board.)
 */
export const QUOTATIONS = [
  'TO BE OR NOT TO BE',
  'A ROSE BY ANY OTHER NAME',
  'ALL THE WORLDS A STAGE',
  'I CAME I SAW I CONQUERED',
  'KNOW THYSELF',
  'GIVE ME LIBERTY OR GIVE ME DEATH',
  'I HAVE A DREAM',
  'ASK NOT WHAT YOUR COUNTRY CAN DO',
  'FOUR SCORE AND SEVEN YEARS AGO',
  'GOVERNMENT OF THE PEOPLE',
  'THE ONLY THING WE HAVE TO FEAR',
  'THAT IS ONE SMALL STEP FOR MAN',
  'I THINK THEREFORE I AM',
  'THE TRUTH SHALL SET YOU FREE',
  'DO UNTO OTHERS AS YOU WOULD',
  'A FRIEND IN NEED IS A FRIEND',
  'TIME IS MONEY',
  'EARLY TO BED AND EARLY TO RISE',
  'FAMILIARITY BREEDS CONTEMPT',
  'NOTHING IS CERTAIN BUT DEATH AND TAXES',
  'A HOUSE DIVIDED CANNOT STAND',
  'GO WEST YOUNG MAN',
  'THE BUCK STOPS HERE',
  'WALK SOFTLY AND CARRY A BIG STICK',
  'A CHICKEN IN EVERY POT',
  'NOTHING TO FEAR BUT FEAR ITSELF',
  'BE THE CHANGE YOU WISH TO SEE',
  'LIVE AND LET LIVE',
  'BETTER TO LIGHT A CANDLE',
  'GOD HELPS THOSE WHO HELP THEMSELVES',
  'NEITHER A BORROWER NOR A LENDER BE',
  'THIS ABOVE ALL TO THINE OWN SELF',
  'WHAT FOOLS THESE MORTALS BE',
  'PARTING IS SUCH SWEET SORROW',
  'THE LADY DOTH PROTEST TOO MUCH',
  'GOODNIGHT SWEET PRINCE',
  'A MAN A PLAN A CANAL PANAMA',
  'EAST IS EAST AND WEST IS WEST',
  'THE MEDIUM IS THE MESSAGE',
  'WAR IS HELL',
  'WE HAVE MET THE ENEMY',
  'CARPE DIEM SEIZE THE DAY',
  'VENI VIDI VICI',
  'E PLURIBUS UNUM',
  'IN GOD WE TRUST',
  'LIBERTY AND JUSTICE FOR ALL',
  'WITH MALICE TOWARD NONE',
  'WHEN IN THE COURSE OF HUMAN EVENTS',
  'WE THE PEOPLE',
  'LIFE LIBERTY AND THE PURSUIT OF HAPPINESS',
  'ALL MEN ARE CREATED EQUAL',
  'GIVE ME YOUR TIRED YOUR POOR',
  'ONE NATION UNDER GOD',
  'OF THE PEOPLE BY THE PEOPLE',
  'A PENNY FOR YOUR THOUGHTS',
  'BIRDS OF A FEATHER',
  'BEAUTY IS TRUTH TRUTH BEAUTY',
  'STOPPING BY WOODS ON A SNOWY EVENING',
  'TWO ROADS DIVERGED IN A WOOD',
  'I WANDERED LONELY AS A CLOUD',
  'I COULD NOT STOP FOR DEATH',
  'TO SLEEP PERCHANCE TO DREAM',
  'THE QUALITY OF MERCY',
  'BREVITY IS THE SOUL OF WIT',
  'A PRIMROSE PATH',
  'AS GOOD AS GOLD',
  'A LITTLE LEARNING IS DANGEROUS',
  'TO ERR IS HUMAN TO FORGIVE DIVINE',
  'HOPE SPRINGS ETERNAL',
  'NO MAN IS AN ISLAND',
  'LESS IS MORE',
  'SEEING IS BELIEVING',
  'STILL WATERS RUN DEEP',
  'TIME AND TIDE WAIT FOR NO MAN',
  'THE PROOF OF THE PUDDING',
] as const;
